import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context7; _forEachInstanceProperty(_context7 = ownKeys(Object(source), true)).call(_context7, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context8; _forEachInstanceProperty(_context8 = ownKeys(Object(source))).call(_context8, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContext, useMemo, useCallback, useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { useActions } from './use-actions';
import { actionsAtom } from '../react-forms';
import { MultiFormContext } from '../multi-form';
import { get } from 'lodash';

function useFormActions(_ref) {
  var groupId = _ref.groupId,
      id = _ref.id,
      validate = _ref.validate,
      handleSubmit = _ref.handleSubmit;

  var _useContext = useContext(MultiFormContext),
      _useContext$formConfi = _useContext.formConfigs,
      formConfigs = _useContext$formConfi === void 0 ? {} : _useContext$formConfi;

  var _useActions = useActions(),
      createHelpers = _useActions.createHelpers,
      _setName = _useActions.setName,
      _validateField = _useActions.validateField,
      validateForms = _useActions.validateForms,
      submitForms = _useActions.submitForms;

  var setActions = useSetRecoilState(actionsAtom({
    groupId: groupId,
    id: id
  }));
  var multiFormValidate = useMemo(function () {
    var _formConfigs$id;

    return formConfigs === null || formConfigs === void 0 ? void 0 : (_formConfigs$id = formConfigs[id]) === null || _formConfigs$id === void 0 ? void 0 : _formConfigs$id.validate;
  }, [id, formConfigs]);
  var multiFormHandleSubmit = useMemo(function () {
    var _formConfigs$id2;

    return formConfigs === null || formConfigs === void 0 ? void 0 : (_formConfigs$id2 = formConfigs[id]) === null || _formConfigs$id2 === void 0 ? void 0 : _formConfigs$id2.handleSubmit;
  }, [id, formConfigs]);
  var createActions = useCallback(function (_ref2) {
    var validate = _ref2.validate,
        handleSubmit = _ref2.handleSubmit;
    return _objectSpread(_objectSpread({}, createHelpers({
      groupId: groupId,
      id: id
    })), {}, {
      setName: function setName() {
        var _context;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _setName.apply(void 0, _concatInstanceProperty(_context = [{
          groupId: groupId,
          id: id
        }]).call(_context, args));
      },
      validateField: function validateField() {
        var _context2;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return _validateField.apply(void 0, _concatInstanceProperty(_context2 = [{
          groupId: groupId,
          id: id,
          validate: validate !== null && validate !== void 0 ? validate : multiFormValidate
        }]).call(_context2, args));
      },
      validateForm: function () {
        var _validateForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _context3;

          var _len3,
              args,
              _key3,
              errors,
              _args = arguments;

          return _regeneratorRuntime.wrap(function _callee$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  for (_len3 = _args.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    args[_key3] = _args[_key3];
                  }

                  _context4.next = 3;
                  return validateForms.apply(void 0, _concatInstanceProperty(_context3 = [{
                    groupId: groupId
                  }, _defineProperty({}, id, {
                    validate: validate !== null && validate !== void 0 ? validate : multiFormValidate
                  })]).call(_context3, args));

                case 3:
                  errors = _context4.sent;
                  return _context4.abrupt("return", get(errors, id));

                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee);
        }));

        function validateForm() {
          return _validateForm.apply(this, arguments);
        }

        return validateForm;
      }(),
      submitForm: function () {
        var _submitForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var _context5;

          var _len4,
              args,
              _key4,
              submissions,
              _args2 = arguments;

          return _regeneratorRuntime.wrap(function _callee2$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  for (_len4 = _args2.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                    args[_key4] = _args2[_key4];
                  }

                  _context6.next = 3;
                  return submitForms.apply(void 0, _concatInstanceProperty(_context5 = [{
                    groupId: groupId
                  }, _defineProperty({}, id, {
                    validate: validate !== null && validate !== void 0 ? validate : multiFormValidate,
                    handleSubmit: handleSubmit !== null && handleSubmit !== void 0 ? handleSubmit : multiFormHandleSubmit
                  })]).call(_context5, args));

                case 3:
                  submissions = _context6.sent;
                  return _context6.abrupt("return", get(submissions, id));

                case 5:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee2);
        }));

        function submitForm() {
          return _submitForm.apply(this, arguments);
        }

        return submitForm;
      }()
    });
  }, [groupId, id, multiFormValidate, multiFormHandleSubmit, createHelpers, _setName, _validateField, validateForms, submitForms]);
  var actions = useMemo(function () {
    return createActions({
      validate: validate,
      handleSubmit: handleSubmit
    });
  }, [createActions, validate, handleSubmit]);
  useEffect(function () {
    setActions(actions);
  }, [actions, setActions]);
  useEffect(function () {
    return function () {
      // If there is a form defined above with a different
      // validate or handleSubmit functions then we want
      // to make sure that we set the actions back again
      // when we unmount this form
      if (formConfigs === null || formConfigs === void 0 ? void 0 : formConfigs[id]) {
        setActions(createActions({
          validate: multiFormValidate,
          handleSubmit: multiFormHandleSubmit
        }));
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return actions;
}

export { useFormActions };